import "prismjs";
import "./prism-bash";
import "prismjs/components/prism-shell-session";
